export const PUZZLES_TEXT = {
  intro: `Hello there!<br />
    I'm <b>Danny Carvajal</b>`,

  logic:
    "When I was a child I met the Rubik's cube. I really liked it and my interest for <i>puzzles</i> leaded me to try chess and got me closer to the <b>Front-End</b> development. I challenge you👆🏻 to find a 5 letters secret word you'll discover solving three small puzzles. Good luck...",

  creativity: `We can solve problems in different ways. But is not until <i>design</i> comes in that the inner magic comes out. I have a serious interest in <b>UX/UI</b> design because it can be a differential for a remarkable experience 🌌.
    `,
};
